import request from "../utils/request";
//清缓存
export function refreshPage() {
  return request({
    url: `/wallpaper/page/refreshPage`,
    method: "post"
  });
}

//关联应用列表
export function getaAllRelationApp() {
  return request({
    url: "/app/all",
    method: "get"
  });
}

//清除page缓存
export function refreshPageResponse(appkey) {
  return request({
    url: "/wallpaper/page/refreshPageResponse?appKey=" + appkey,
    method: "post"
  });
}

//清除category缓存
export function refreshCategoryResponse(appkey) {
  return request({
    url: "/wallpaper/category/refreshCategory?appKey=" + appkey,
    method: "post"
  });
}


// 清楚
export function refreshResourceKeyResponse(params){
  return request({
    url:'/wallpaper/refreshResource',
    method:"post",
    data:params
  })
}